import { render, staticRenderFns } from "./cardPermission.vue?vue&type=template&id=7a6a531e&scoped=true&"
import script from "./cardPermission.vue?vue&type=script&lang=js&"
export * from "./cardPermission.vue?vue&type=script&lang=js&"
import style0 from "./cardPermission.vue?vue&type=style&index=0&id=7a6a531e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6a531e",
  null
  
)

export default component.exports